import { render, staticRenderFns } from "./proxy.vue?vue&type=template&id=7d2383fc&scoped=true&"
import script from "./proxy.vue?vue&type=script&lang=js&"
export * from "./proxy.vue?vue&type=script&lang=js&"
import style0 from "./proxy.vue?vue&type=style&index=0&id=7d2383fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2383fc",
  null
  
)

export default component.exports